// extracted by mini-css-extract-plugin
module.exports = {"heroLight":"gttl-landing-page_heroLight__PIgek","heroLightGradient":"gttl-landing-page_heroLightGradient__REpck","video_container":"gttl-landing-page_video_container__jNXAI"};